import React from "react";
import { Link, NavLink } from "react-router-dom";

import UserTour from "../UserTour/UserTour";
import About from '../About/About';

import "./Header.css";
import Image from "./Nyawira-Wanjiru.png";

const screenWidth = window.screen.width;

const headerItems = (
  <div>
    <nav className="navbar fixed-top navbar-expand-lg navbar-site">
      <Link id="brand-name" className="navbar-brand" to="/">
        <img id="logo" src={Image} alt="logo"/>
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div
        className="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul id="personal-links" className="navbar-nav mr-auto">
          <li id="home-link" className="nav-item active">
            <NavLink className="nav-link" to="/">
              Home 
            </NavLink>
          </li>
          <li id="about-link" className="nav-item dropdown">
            <NavLink
              className="nav-link dropdown-toggle"
              to="/"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              About Me
            </NavLink>
            <About />
           </li> 
          </ul>
          <div id="contact-link"className="my-2 my-lg-0">
            <a role="button" id="contact" className="nav-item btn btn-outline-secondary btn-lg" href="mailto:leenjiru1@gmail.com">
                <p className="nav-link mb-0 pt-0 pb-0 pl-5 pr-5">
                  Contact Me
              </p>
            </a>
          </div>
        </div>
      </nav>
    </div>);

const tourHeader = 
<div>
<UserTour />
 {headerItems}
</div>;

const Header = () => {
  return (
    <div className="header">
      {screenWidth < 750 ? headerItems : tourHeader}
    </div>
  );
}

export default Header;
